import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  PARAMETROS_SISTEMA_EDITAR_BEGIN,
  PARAMETROS_SISTEMA_EDITAR_SUCCESS,
  PARAMETROS_SISTEMA_EDITAR_FAILURE,
  PARAMETROS_SISTEMA_EDITAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function editar(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: PARAMETROS_SISTEMA_EDITAR_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissEditarError() {
  return {
    type: PARAMETROS_SISTEMA_EDITAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on PARAMETROS_SISTEMA_EDITAR_BEGIN actions
export function* doEditar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const ParametroSistemaApi = new Services['ParametroSistemaApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield ParametroSistemaApi.replaceById(action.data.Nome, action.data);
  } catch (err) {
    yield put({
      type: PARAMETROS_SISTEMA_EDITAR_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(PARAMETROS_SISTEMA_EDITAR_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: PARAMETROS_SISTEMA_EDITAR_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(PARAMETROS_SISTEMA_EDITAR_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchEditar() {
  yield takeLatest(PARAMETROS_SISTEMA_EDITAR_BEGIN, doEditar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case PARAMETROS_SISTEMA_EDITAR_BEGIN:
      return {
        ...state,
        editarPending: true,
        editarError: null,
      };

    case PARAMETROS_SISTEMA_EDITAR_SUCCESS:
      return {
        ...state,
        registro: action.data,
        editarPending: false,
        editarError: null,
      };

    case PARAMETROS_SISTEMA_EDITAR_FAILURE:
      return {
        ...state,
        editarPending: false,
        editarError: action.data.error,
      };

    case PARAMETROS_SISTEMA_EDITAR_DISMISS_ERROR:
      return {
        ...state,
        editarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/redux/editar.js